/**
 *
 * Asynchronously loads the component for DecoratorDetail
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
